import React, { useEffect, useState, PureComponent } from 'react';

import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';

import ActivityIcon from './ActivityIcon';

export default function Quiz ({type, activity, remove, errors, register, name, icon, saveIcon, hideIcon}) {
    
    console.log(icon);

    return (
        
        <>
        
            <div className="title"> 
                <div>
                    <div className="icon"><img src={icon} alt="" /></div>
                    <div className="name">Settings {name}</div>
                </div>
                <div>
                    <div className="icon qrcode"><QrcodePurple /></div>
                    <div className="icon remove" onClick={remove}><Remove /></div>
                </div>
            </div>
            
            <ActivityIcon icon={icon} saveIcon={saveIcon} hideIcon={hideIcon} />
            
            <label>Enter {name} name</label>
            <input 
                type="text"
                {...register("name", { required: "Name is required" })}
                placeholder={name + " name"}
                defaultValue={activity['name']}
            />
            <div className="error">{errors.name?.message}</div>                                
            
            <div className="subtitle">{name} question</div>
            <label>Enter question for the {name}</label>
            <input 
                type="text"
                {...register("data[question]", { required: "Question is required" })}
                placeholder={"Question for the " + name}
                defaultValue={activity['data']['question']}
            />
            <div className="error">{errors['data'] ? errors['data']['question']?.message : ''}</div>
            
            <div className="subtitle">Responses</div>
                                            
            { 
                [1,2,3,4].map((i) => (
                        
                    <div key={i}>
                        
                        {name=="Poll" && i==1 ?
                            <>
                                <label>Enter correct answer</label>
                                <input 
                                    type="text"
                                    {...register("data[answer"+i+"]", { required: "Response is required" })}
                                    placeholder={"Correct answer"}
                                    defaultValue={activity['data']['answer'+i]}                                                
                                />
                            </>
                        :
                            <>
                                <label>Enter responses</label>
                                <input 
                                    type="text"
                                    {...register("data[answer"+i+"]", { required: "Response is required" })}
                                    placeholder={"Responses name "+(i)}
                                    defaultValue={activity['data']['answer'+i]}                                                
                                />
                            </>
                        }
                            
                        <div className="error">{errors["data"] ? errors["data"]["answer"+i]?.message : '' }</div>
                    </div>                                    
                
                ))
            }
            
        </>
        
    )

}        
        
